import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { labRequestDeliveryResult } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTDELIVERYRESULT,
  DELETE_LABREQUESTDELIVERYRESULT,
  GET_LABREQUESTDELIVERYRESULTS,
  UPDATE_LABREQUESTDELIVERYRESULT
} from "./actionTypes";
import {
  addLabRequestDeliveryResultFail,
  addLabRequestDeliveryResultSuccess,
  deleteLabRequestDeliveryResultFail,
  deleteLabRequestDeliveryResultSuccess,
  getLabRequestDeliveryResultsFail,
  getLabRequestDeliveryResultsSuccess,
  setState,
  updateLabRequestDeliveryResultFail,
  updateLabRequestDeliveryResultSuccess,
} from "./actions";
//Include Both Helper File with needed methods

function* fetchLabRequestDeliveryResults( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, labRequestDeliveryResult, params.toString());
    yield put(setState(false))
    yield put(getLabRequestDeliveryResultsSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestDeliveryResultsFail(error));
  }
}

function* updateLabRequestDeliveryResult ({payload: labRequestDeliveryResultObj }) {
  try {
    const { id, recordStatus, ...rest } = labRequestDeliveryResultObj;
    yield call(patchApiCall, `${labRequestDeliveryResult}/${id}`, rest);
    const response = yield call(getTable,`${labRequestDeliveryResult}/${labRequestDeliveryResultObj.id}`);
    yield put(updateLabRequestDeliveryResultSuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateLabRequestDeliveryResultFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* deleteLabRequestDeliveryResult ({payload: labRequestDeliveryResultObj}) {
  try {
    yield call(deleteApiCall,`${labRequestDeliveryResult}/${labRequestDeliveryResultObj.id}`);
    yield put(deleteLabRequestDeliveryResultSuccess(labRequestDeliveryResultObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteLabRequestDeliveryResultFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingLabRequestDeliveryResult ({ payload: labRequestDeliveryResultObj}) {
  try {
    const response = yield call(postApiCall, labRequestDeliveryResult ,labRequestDeliveryResultObj);
    const response1 = yield call(getTable,`${labRequestDeliveryResult}/${response.id}`);
    yield put(addLabRequestDeliveryResultSuccess(response1));
    toast.success('Registro agregado correctamente')
  } catch (error) {
    yield put(addLabRequestDeliveryResultFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* labRequestDeliveryResultsSaga() {
  yield takeEvery(GET_LABREQUESTDELIVERYRESULTS, fetchLabRequestDeliveryResults);
  yield takeEvery(ADD_NEW_LABREQUESTDELIVERYRESULT, postingLabRequestDeliveryResult);
  yield takeEvery(UPDATE_LABREQUESTDELIVERYRESULT, updateLabRequestDeliveryResult);
  // yield takeEvery(UPDATE_LABREQUESTDELIVERYRESULT, updateLabRequestDeliveryResultStatus);
  yield takeEvery(DELETE_LABREQUESTDELIVERYRESULT, deleteLabRequestDeliveryResult);
}

export default labRequestDeliveryResultsSaga;
